import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CATEGORIES, fmt } from "@/lib/api";

const NO_STITCH = ["Suit", "Saree", "Others"];
const STATUSES = ["New", "With Karigar", "Ready", "In Shop", "Delivered"];

export const emptyProduct = () => ({
  name: "", category: "Suit", quantity: 1, customer_price: 0,
  fabric_cost: 0, stitching_cost: 0, karigar_cost: 0,
  status: "New", karigar_id: "", remarks: "",
});

export const productProfit = (p) => {
  const stitch = NO_STITCH.includes(p.category) ? 0 : Number(p.stitching_cost) || 0;
  return ((Number(p.customer_price) || 0) - (Number(p.fabric_cost) || 0) - stitch - (Number(p.karigar_cost) || 0)) * (Number(p.quantity) || 1);
};

export const cleanProduct = (p) => ({
  ...p,
  quantity: Number(p.quantity) || 1,
  customer_price: Number(p.customer_price) || 0,
  fabric_cost: Number(p.fabric_cost) || 0,
  stitching_cost: NO_STITCH.includes(p.category) ? 0 : Number(p.stitching_cost) || 0,
  karigar_cost: Number(p.karigar_cost) || 0,
  karigar_id: p.karigar_id || null,
});

export const ProductFields = ({ value, onChange, karigars, idx = 0 }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const showStitching = !NO_STITCH.includes(value.category);
  const label = "text-[10px] uppercase tracking-widest text-muted-foreground";

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1">
          <span className={label}>Product Name *</span>
          <Input data-testid={`product-name-${idx}`} placeholder="e.g. Bridal Lehenga" value={value.name} onChange={(e) => set("name", e.target.value)} />
        </div>
        <div className="space-y-1">
          <span className={label}>Category</span>
          <Select value={value.category} onValueChange={(v) => set("category", v)}>
            <SelectTrigger data-testid={`product-category-${idx}`}><SelectValue /></SelectTrigger>
            <SelectContent>{CATEGORIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>
      <div className={`grid grid-cols-2 ${showStitching ? "sm:grid-cols-5" : "sm:grid-cols-4"} gap-3`}>
        <div className="space-y-1">
          <span className={label}>Qty</span>
          <Input data-testid={`product-quantity-${idx}`} type="number" min="1" value={value.quantity} onChange={(e) => set("quantity", e.target.value)} />
        </div>
        <div className="space-y-1">
          <span className={label}>Price ₹</span>
          <Input data-testid={`product-customer-price-${idx}`} type="number" min="0" value={value.customer_price} onChange={(e) => set("customer_price", e.target.value)} />
        </div>
        <div className="space-y-1">
          <span className={label}>Fabric ₹</span>
          <Input data-testid={`product-fabric-cost-${idx}`} type="number" min="0" value={value.fabric_cost} onChange={(e) => set("fabric_cost", e.target.value)} />
        </div>
        {showStitching && (
          <div className="space-y-1">
            <span className={label}>Stitching ₹</span>
            <Input data-testid={`product-stitching-cost-${idx}`} type="number" min="0" value={value.stitching_cost} onChange={(e) => set("stitching_cost", e.target.value)} />
          </div>
        )}
        <div className="space-y-1">
          <span className={label}>Karigar ₹</span>
          <Input data-testid={`product-karigar-cost-${idx}`} type="number" min="0" value={value.karigar_cost} onChange={(e) => set("karigar_cost", e.target.value)} />
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        <div className="space-y-1">
          <span className={label}>Status</span>
          <Select value={value.status} onValueChange={(v) => set("status", v)}>
            <SelectTrigger data-testid={`product-status-${idx}`}><SelectValue /></SelectTrigger>
            <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="space-y-1">
          <span className={label}>Assigned Karigar</span>
          <Select value={value.karigar_id || "none"} onValueChange={(v) => set("karigar_id", v === "none" ? "" : v)}>
            <SelectTrigger data-testid={`product-karigar-${idx}`}><SelectValue placeholder="None" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">None</SelectItem>
              {karigars?.map((k) => <SelectItem key={k.id} value={k.id}>{k.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1">
          <span className={label}>Remarks</span>
          <Input data-testid={`product-remarks-${idx}`} placeholder="Optional" value={value.remarks} onChange={(e) => set("remarks", e.target.value)} />
        </div>
      </div>
      <p className="text-xs text-muted-foreground">
        Profit: <span className={`font-medium ${productProfit(value) >= 0 ? "text-emerald-600" : "text-red-500"}`}>{fmt(productProfit(value))}</span>
      </p>
    </div>
  );
};
